import React from "react"
import { TextTag } from "../../atoms"
import "./Tag.scss"

const Tag = (props) => {
  const { text, icon, onClickIcon, ...rest } = props
  return (
    <div className="tag-container" {...rest}>
      <TextTag textType="smallTextPrimary">{text}</TextTag>
      {icon && (
        <TextTag
          onClick={onClickIcon}
          textType="smallTextPrimary"
          className="icon"
        >
          ?
        </TextTag>
      )}
    </div>
  )
}

Tag.defaultProps = {
  text: "",
  icon: false,
  onClickIcon: null,
}

export default Tag
